export default "__VITE_ASSET__BbTbODkL__"